import Axios from "axios";

const currenciesForSelect =  {
    namespaced: true,
    state: {
        list: [],
        loaded: false,
        promise: null,
    },
    mutations: {
        SET_LIST: (state, payload) => {
            state.list = payload;
        },
        SET_LOADED: (state, payload) => {
            state.loaded = payload;
        },
        SET_PROMISE: (state, payload) => {
            state.promise = payload;
        },
    },
    actions: {
        async loadList ({ state, commit }) {
            if (state.promise) {
                return state.promise;
            }

            let promise = Axios({
                url: '/api/v1/limits/currencies-for-select',
                method: 'GET',
            }).then(resp => {
                commit('SET_LIST', resp.data.map(({label, value}) => { return {label, value }}));
                commit('SET_LOADED', true);
            });

            commit('SET_PROMISE', promise);

            return promise;
        },
    },
    getters: {
        list: (state) => state.list,
        loaded: (state) => state.loaded,
    }
};

export default currenciesForSelect;
